
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/global-auth/sso",
      function () {
        return require("private-next-pages/global-auth/sso/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/global-auth/sso"])
      });
    }
  